import React, { useEffect, useState } from 'react';
import { HashIcon } from 'lucide-react';
import { BurnoutCard } from './BurnoutCard';
import { motion } from 'framer-motion';
const messages = [{
  user: 'Rachel Kim',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150',
  message: "Hey team, noticed everyone's been putting in extra hours lately. Let's chat about workload distribution? 🤔",
  time: '3:30 PM'
}, {
  user: 'Mark Chen',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150',
  message: 'Good call! Been feeling a bit stretched with the upcoming release.',
  time: '3:31 PM'
}, {
  user: 'Sarah Miller',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=150',
  message: "Let's do a quick retro and adjust our sprint commitments accordingly 📊",
  time: '3:32 PM'
}, {
  user: 'David Park',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&q=80&w=150',
  message: 'I can help redistribute some of the critical path tasks.',
  time: '3:33 PM'
}, {
  user: 'Emma Wilson',
  avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&q=80&w=150',
  message: "Great idea! Let's also schedule some recurring breaks between deep work sessions ⏰",
  time: '3:34 PM'
}, {
  user: 'Alex Thompson',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150',
  message: 'Loving this proactive approach to team wellbeing! 💪',
  time: '3:35 PM'
}];
export const BurnoutThread = () => {
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
      }
    }, {
      threshold: 0.5
    });
    const element = document.querySelector('.burnout-thread-container');
    if (element) {
      observer.observe(element);
    }
    return () => observer.disconnect();
  }, []);
  return <div className="w-full h-full bg-white relative burnout-thread-container" data-id="element-179">
      {/* Channel Header */}
      <motion.div className="bg-gray-50 border-b border-gray-200 px-4 py-2 flex items-center" animate={{
      opacity: isInView ? 0 : 1
    }} transition={{
      duration: 0.5,
      delay: 0.35,
      ease: 'easeOut'
    }} data-id="element-180">
        <HashIcon size={18} className="text-gray-500 mr-2" data-id="element-181" />
        <span className="text-gray-800 font-medium" data-id="element-182">team-wellness</span>
        <span className="ml-2 text-gray-500 text-sm" data-id="element-183">15 members</span>
      </motion.div>
      {/* Messages Container */}
      <motion.div className="p-4 space-y-4" style={{
      filter: 'blur(1.5px) saturate(0.7)'
    }} animate={{
      y: isInView ? [-400, -800] : 0
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear',
      repeatType: 'loop'
    }} data-id="element-184">
        {[...messages, ...messages, ...messages].map((msg, index) => <div key={index} className="flex items-start" data-id="element-185">
            <img src={msg.avatar} alt={msg.user} className="w-8 h-8 rounded mr-3" data-id="element-186" />
            <div data-id="element-187">
              <div className="flex items-baseline" data-id="element-188">
                <span className="font-bold text-gray-900 mr-2" data-id="element-189">{msg.user}</span>
                <span className="text-xs text-gray-500" data-id="element-190">{msg.time}</span>
              </div>
              <p className="text-gray-800 mt-1" data-id="element-191">{msg.message}</p>
            </div>
          </div>)}
      </motion.div>
      {/* Card Overlay */}
      <motion.div className="absolute top-1/2 left-1/2" style={{
      x: '-50%',
      y: '-50%'
    }} initial={{
      opacity: 0,
      y: 'calc(-50% + 20px)'
    }} animate={{
      opacity: isInView ? 1 : 0,
      y: isInView ? '-50%' : 'calc(-50% + 20px)'
    }} transition={{
      duration: 0.35,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} data-id="element-192">
        <BurnoutCard isInView={isInView} value={18} trend="-4" title="Burnout" data-id="element-193" />
      </motion.div>
    </div>;
};